import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { url: String }

  connect() {
    new TomSelect(this.element, {
      valueField: 'id',
      labelField: 'text',
      searchField: 'text',
      load: (query, callback) => {
        if (!query.length) return callback();
        fetch(`${this.urlValue}?term=${encodeURIComponent(query)}`)
          .then(response => response.json())
          .then(json => callback(json))
          .catch(() => callback());
      },
      maxItems: 1
    });
  }
}
